export default {
      id: "arrow-back-usage",
      viewBox: "0 0 11 17",
      url: __webpack_public_path__ + "img/icons.f163a2c6.svg#arrow-back",
      toString: function () {
        return this.url;
      }
    }